module.exports = __webpack_public_path__ + "static/spotifylogo-11dc437ab8ef0c32289c092083d20068.png";